import { render, staticRenderFns } from "./CombinationsReview.vue?vue&type=template&id=31ee6c2d&scoped=true"
import script from "./CombinationsReview.vue?vue&type=script&lang=js"
export * from "./CombinationsReview.vue?vue&type=script&lang=js"
import style0 from "./CombinationsReview.vue?vue&type=style&index=0&id=31ee6c2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ee6c2d",
  null
  
)

export default component.exports